export const store = process.env.NODE_ENV === 'production'
  ? require('./configureReduxStore.production.jsx').prodStore
  : require('./configureReduxStore.development.jsx').devStore;
